<template>
  <div
    :class="{
      'sidebar-list-item': true,
      bordered: bordered,
      centered: centered,
      active: active,
      gebiedsmeldingicon: gebiedsmeldingicon
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    bordered: {
      type: Boolean,
      required: false,
      default: false
    },
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    centered: {
      type: Boolean,
      required: false,
      default: false
    },
    gebiedsmeldingicon: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-list-item {
  display: flex;
  background: #fff;
  padding: $spacing-3;
  cursor: pointer;

  &.bordered {
    &:not(:first-child) {
      border-top: 1px solid $color-gray-1;
    }
    .sidebar-list-item__left {
      &__icon {
        width: 24px;
        height: 24px;
        padding: 0;
        border-radius: 0;
        background: transparent;
      }
    }
  }

  &.centered {
    align-items: center;
  }

  &.active {
    background: $color-gray-1;
  }

  &__left {
    &__icon {
      width: 56px;
      height: 56px;
    }
  }

  &.gebiedsmeldingicon {
    .sidebar-list-item__left {
      &__icon-container {
        background: $color-green-1;
        border-radius: 100%;
        width: 45px;
        height: 45px;
        box-shadow: 0 0 5px #969696;
        border: 3px solid #fff;
        position: relative;
        margin-left: 6px;
        margin-right: 6px;

        &__icon {
          width: 32px;
          height: 32px;
          border-radius: 100%;
          background-color: inherit;
          padding: $spacing-1;
          padding: 6px;
          position: relative;
          top: 3px;
          left: 3px;
        }
      }
    }
  }

  &__middle {
    padding-left: $spacing-3;
    padding-right: $spacing-3;
    flex: 1;

    &__text-title {
      @extend %text-title-3;
      word-break: break-word;
      margin-bottom: $spacing-1;

      &.read {
        font-weight: 400;
      }
    }
    &__text-subtitle {
      @extend %text-mini;
      color: $color-black-2;

      &.bigger-subtitle {
        @extend %text-small;
        color: $color-black-3;
      }
    }
  }

  &__right {
    margin-left: auto;
    align-self: center;

    &__icon {
      width: 24px;
      height: 24px;

      path {
        fill: $color-black-1;
      }
    }
  }
}
</style>
